const CONSENT_KEY = "cookie-consent";
const CONSENT_ACCEPTED = "accepted";
const CONSENT_DECLINED = "declined";

const GRANTED_CONSENT = {
  ad_storage: "granted",
  ad_user_data: "granted",
  ad_personalization: "granted",
  analytics_storage: "granted",
};

const DENIED_CONSENT = {
  ad_storage: "denied",
  ad_user_data: "denied",
  ad_personalization: "denied",
  analytics_storage: "denied",
};

function updateConsent(granted) {
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", granted ? GRANTED_CONSENT : DENIED_CONSENT);
  }
}

function initCookieConsent() {
  const banner = document.getElementById("cookie-consent");
  const acceptBtn = document.getElementById("cookie-accept");
  const declineBtn = document.getElementById("cookie-decline");

  if (!banner) {
    return;
  }

  const consent = localStorage.getItem(CONSENT_KEY);

  if (!consent) {
    requestAnimationFrame(() => {
      banner.classList.add("visible");
    });
  }

  if (acceptBtn) {
    acceptBtn.addEventListener("click", () => {
      localStorage.setItem(CONSENT_KEY, CONSENT_ACCEPTED);
      banner.classList.remove("visible");
      updateConsent(true);
    });
  }

  if (declineBtn) {
    declineBtn.addEventListener("click", () => {
      localStorage.setItem(CONSENT_KEY, CONSENT_DECLINED);
      banner.classList.remove("visible");
      updateConsent(false);
    });
  }
}

export function init() {
  const consent = localStorage.getItem(CONSENT_KEY);
  if (consent === CONSENT_ACCEPTED) {
    updateConsent(true);
  } else if (consent === CONSENT_DECLINED) {
    updateConsent(false);
  }

  initCookieConsent();
}
